export const usersRoles = {
  ADMIN: 5,
  EXPERT: 3,
  BUYER: 0,
};
